<script lang='ts'>
  import * as _ from 'lodash';
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Icon from '@shared/svelte/Components/Icon.svelte';
  import SizeWidget from '@distributor/svelte/SellSheet/Components/SizeWidget.svelte';
  import type { DistributorSellSheet } from '@shared/types/SellSheet';
  import Modal from '@shared/svelte/Components/Modal.svelte';
  import FormErrors from "@shared/svelte/Components/FormErrors.svelte";
  import ImageUploadWidget from '@distributor/svelte/SellSheet/Components/ImageUploadWidget.svelte';

  export let sellSheet: DistributorSellSheet;
  export let page:any;
  export let productLine:any;
  export let showEditModal:boolean;
  export let finishSaveEdits;
  export let cancelEditsCB;

  let integrated = sellSheet?.distributor?.integrated;

  let saveImage;
  let errors;

  const cancelEdits = function() {
    cancelEditsCB();
  }

  const saveEdits = async function() {
    page.loadingProducts = true;
    try {
      let res = await HttpPromise({
        method: 'PUT',
        url: `/api/distributor/sell_sheets/${sellSheet.id}/sell_sheet_product_lines/${productLine.id}`,
        data: {
          sell_sheet_product_line: _.omit(productLine, 'editingCopy')
        }
      })

      try {
        let obj = await saveImage();
        if (obj && obj.cloudinary_image_url) {
          res.cloudinary_image_url = obj.cloudinary_image_url;
          res.image_upload_id = obj.id;
        }
      } catch(error) {
        console.error(error)
      }
      finishSaveEdits(res)
    } catch(error) {
      console.error(error)
      page.loadingProducts = false;
      errors = {messages: [error]};
    }
  };
</script>

<Modal show={showEditModal} closeOnBackgroundClick={false} fizzModal={false} size={'medium'} overflow={'auto'}>
  <div class="background-white grid-row" style="width: 95vw; max-width: 600px;">
    <FormErrors errors={errors} />
    <div class="modal__header padding--small">
      <span class="default-subheader--bold default-title--bold--md margin-top--smaller">Edit Product</span>
      <span class="float-right"><Icon type='X' height="16" width="16"
        extraClassNames="cursor-pointer opacity-60 display-inline-block margin-top--smallest" onPress={cancelEdits} /></span>
    </div>

    <div class="sell-sheet__edit_product_modal_content padding--1 grid-col">
      <div class="margin-right--smaller margin-top--smaller margin-left--smaller">
        <div class="margin-bottom--smaller">
          <div class="label input__label--left padding-bottom--smallest align-left">
            Name
          </div>
          <div class="input-wrapper full-width">
            <input type="text"
                    class="input" disabled={true}
                    value={productLine.name} required>
          </div>
        </div>
        <div class="margin-bottom--smaller">
          <div class="label input__label--left padding-bottom--smallest align-left">Manufacturer</div>
          <div class="input-wrapper full-width">
            <input type="text" data-testid='ss-manufacturer'
                    class="input" disabled={integrated}
                    bind:value={productLine.manufacturer}>
          </div>
        </div>
        <div class="margin-bottom--smaller">
          <div class="label input__label--left padding-bottom--smallest align-left">Type</div>
          <div class="input-wrapper full-width">
            <input type="text" data-testid='ss-type'
                    class="input" disabled={integrated}
                    bind:value={productLine.category}>
          </div>
        </div>
        <div class="margin-bottom--smaller">
            <div class="label input__label--left padding-bottom--smallest align-left">ABV %</div>
            <div class="input-wrapper">
              <input type="text" data-testid='ss-abv'
                      class="input" disabled={integrated}
                      placeholder="12"
                      bind:value={productLine.abv}>
            </div>
        </div>
        {#if productLine.product_type_name == "Wine"}
          <div class="margin-bottom--smaller">
            <div class="label input__label--left padding-bottom--smallest align-left">Vintage Years</div>
            <div class="input-wrapper full-width">
              <input type="text" data-testid='ss-vintage'
                      class="input" disabled={integrated}
                      bind:value={productLine.vintage_years}>
            </div>
          </div>
        {/if}
        {#if productLine.product_type_name == "Wine"}
          <div class="margin-bottom--smaller">
            <div class="label input__label--left padding-bottom--smallest align-left">Appellation</div>
            <div class="input-wrapper full-width">
              <input type="text" data-testid='ss-appellation'
                      class="input" disabled={integrated}
                      bind:value={productLine.wine_appellation}>
            </div>
          </div>
        {/if}
        {#if productLine.product_type_name == "Wine"}
          <div class="margin-bottom--smaller">
            <div class="label input__label--left padding-bottom--smallest align-left">Region</div>
            <div class="input-wrapper full-width">
              <input type="text" data-testid='ss-region'
                      class="input" disabled={integrated}
                      bind:value={productLine.wine_region}>
            </div>
          </div>
        {/if}
        {#if productLine.product_type_name == "Wine"}
          <div class="margin-bottom--smaller">
            <div class="label input__label--left padding-bottom--smallest align-left">Varietal</div>
            <div class="input-wrapper full-width">
              <input type="text" data-testid='ss-varietal'
                      class="input" disabled={integrated}
                      bind:value={productLine.wine_varietal}>
            </div>
          </div>
        {/if}
        <SizeWidget
          productLine={productLine}
        />

        <ImageUploadWidget
          {productLine}
          bind:loading={page.loading}
          bind:saveImage>
        </ImageUploadWidget>

        <div class="margin-bottom--smaller">
          <div class="label input__label--left padding-bottom--smallest align-left">Tasting Notes</div>
          <div class="input-wrapper textarea full-width s5 margin-bottom--smaller">
            <textarea class="input" disabled={integrated}
                      placeholder={integrated ? "No Tasting Notes" : "Add Tasting Notes Here"}
                      bind:value={productLine.tasting_notes}></textarea>
          </div>
        </div>
        <div class="margin-bottom--smaller">
          <div class="label input__label--left padding-bottom--smallest align-left">Additional Notes</div>
          <div class="input-wrapper textarea full-width s5 margin-bottom--smaller">
            <textarea class="input"
                      placeholder="Add Description Here (ex. Deal Notes)"
                      bind:value={productLine.additional_notes}></textarea>
          </div>
        </div>

        <div class="margin-bottom--smaller">
          <div class="label input__label--left padding-bottom--smallest align-left">Description</div>
          <div class="input-wrapper textarea full-width s5 margin-bottom--smaller">
            <textarea class="input" disabled={integrated}
                      placeholder={integrated ? "No Description" : "Add Description Here"}
                      bind:value={productLine.description}></textarea>
          </div>
        </div>
      </div>
    </div>

    <footer class='fizz-modal-footer fizz-inset-square-16 fizz-flex-row fizz-justify-end fizz-surface
    fizz-padded-border-top sticky-footer'>
      <button class="fizz-button float-left"
        on:click={cancelEdits}>
        Cancel
      </button>
      <button class="fizz-button-primary" on:click={saveEdits} disabled={page.loadingProducts}>
        Save
      </button>
    </footer>
  </div>

</Modal>